@use '@/scss/underscore' as _;

.regenerateButton {
  margin-top: _.unit(3);
}

.signingKeyField {
  width: 100%;
}
